import { addLocaleMessages } from '@/i18n';

const cn = {
    byHierarchy: '按层级查看', byComparison: '跨 Issue 对比',
    title: 'Issue 层级关系', level: '第 {level} 层', parents: '前置 Issue', root: '独立一级',
    invalid: '层级关系待核对，请让助手修正；仍可查看和编辑已有策略。',
    blocked: '暂未生成可用的案件汇总，请继续分析或刷新结果。',
    staleIntegration: '案件汇总尚未生成或已过期，请刷新后继续。',
    refresh: '刷新案件汇总', refreshMessage: '请对驳回分析数据 {id} 使用 integrate_only 刷新汇总，保留当前逐项策略，刷新后展示并等待用户确认。',
    regenerateHint: '按已保存的层级关系重新分析所选 Issue 及后续依赖 Issue，保留其他分支。',
    status: { completed: '已完成', evidence_extracted: '已提取证据', running: '分析中', failed: '待重新分析' },
};
const en = {
    byHierarchy: 'By hierarchy', byComparison: 'Across issues',
    title: 'Issue hierarchy', level: 'Level {level}', parents: 'Preceding issues', root: 'Independent root',
    invalid: 'Ask the assistant to repair the hierarchy. Saved strategies remain available for review and editing.',
    blocked: 'A case summary is not available yet. Continue analysis or refresh the results.',
    staleIntegration: 'The case summary is missing or stale. Refresh it to continue.',
    refresh: 'Refresh integration', refreshMessage: 'Use integrate_only to refresh integration for rejection data {id}, preserving current issue strategies. Show the updated result and await user confirmation.',
    regenerateHint: 'Reanalyze selected issues and their dependent issues using the saved hierarchy, preserving other branches.',
    status: { completed: 'Complete', evidence_extracted: 'Evidence extracted', running: 'Analyzing', failed: 'Reanalysis needed' },
};
const tw = {
    byHierarchy: '按層級檢視', byComparison: '跨 Issue 比較',
    title: 'Issue 層級關係', level: '第 {level} 層', parents: '前置 Issue', root: '獨立一級',
    invalid: '層級關係待核對，請讓助手修正；仍可檢視和編輯已有策略。',
    blocked: '尚未產生可用的案件彙總，請繼續分析或更新結果。',
    staleIntegration: '案件彙總尚未產生或已過期，請更新後繼續。',
    refresh: '更新案件彙總', refreshMessage: '請對駁回分析資料 {id} 使用 integrate_only 更新彙總，保留目前逐項策略，更新後展示並等待使用者確認。',
    regenerateHint: '按已儲存層級重新分析所選 Issue 及後續依賴 Issue，保留其他分支。',
    status: { completed: '已完成', evidence_extracted: '已提取證據', running: '分析中', failed: '待重新分析' },
};
const jp = {
    byHierarchy: '階層別', byComparison: 'Issue 間の比較',
    title: 'Issue の階層関係', level: '第 {level} 階層', parents: '先行 Issue', root: '独立した第1階層',
    invalid: '階層関係の修正をアシスタントに依頼してください。既存の方針は引き続き確認・編集できます。',
    blocked: '案件全体の方針が未作成です。分析を続行するか、結果を更新してください。',
    staleIntegration: '全体方針が未作成または古くなっています。更新して続行してください。',
    refresh: '全体方針を更新', refreshMessage: '拒絶分析データ {id} に integrate_only を使用し、個別方針を保持して全体方針を更新してください。結果を表示し、ユーザーの確認を待ってください。',
    regenerateHint: '保存済みの階層に従って選択した Issue と依存する後続 Issue を再分析し、ほかの分岐を保持してください。',
    status: { completed: '完了', evidence_extracted: '証拠抽出済み', running: '分析中', failed: '再分析が必要' },
};

addLocaleMessages('cn', { rejectionHierarchy: cn });
addLocaleMessages('en', { rejectionHierarchy: en });
addLocaleMessages('tw', { rejectionHierarchy: tw });
addLocaleMessages('jp', { rejectionHierarchy: jp });
